import { Box, Skeleton } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';

const AvaiableTablesSkeleton = () => {
  // Create skeleton rows for the table
  const skeletonRows = Array.from({ length: 10 }, (_, index) => ({
    id: index,
    date: (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Skeleton variant="text" width={100} height={24} />
      </Box>
    ),
    time: (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Skeleton variant="text" width={120} height={24} />
      </Box>
    ),
    available_covers_count: (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Skeleton variant="text" width={60} height={24} />
      </Box>
    ),
  }));

  // Define columns to match the actual table
  const columns: GridColDef[] = [
    {
      field: 'date',
      headerName: 'Date',
      flex: 1,
      headerClassName: 'custom-header',
      renderCell: params => params.value,
    },
    {
      field: 'time',
      headerName: 'Time',
      flex: 1,
      headerClassName: 'custom-header',
      renderCell: params => params.value,
    },
    {
      field: 'available_covers_count',
      headerName: 'Available Covers',
      flex: 1,
      headerClassName: 'custom-header',
      renderCell: params => params.value,
    },
  ];

  return (
    <Box sx={{ height: '100%', width: '100%' }}>
      <DataGrid
        rows={skeletonRows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 100 },
          },
        }}
        pageSizeOptions={[5, 10, 25, 50, 75, 100]}
        pagination
        disableRowSelectionOnClick
        sx={{
          borderRadius: '8px',
          color: 'rgba(107, 111, 128, 1)',
          '& .MuiDataGrid-root': {
            borderRadius: '8px',
            overflow: 'hidden',
          },
          '& .MuiDataGrid-main': {
            borderRadius: '8px',
            overflow: 'hidden',
          },
          '& .MuiDataGrid-cell': {
            display: 'flex',
            alignItems: 'center',
          },
          '& .MuiDataGrid-columnHeader': {
            display: 'flex',
            alignItems: 'center',
            bgcolor: '#F8F9FC',
          },
          '& .custom-header': {
            bgcolor: '#F8F9FC',
            color: 'custom.textBlue',
            fontSize: '14px',
            fontWeight: 600,
            padding: '12px 16px',
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            color: 'rgba(43, 45, 63, 1)',
            fontWeight: 600,
          },
          '& .MuiDataGrid-row.Mui-selected': {
            backgroundColor: 'transparent !important',
            border: 'none !important',
          },
          '& .MuiDataGrid-row.Mui-selected:hover': {
            backgroundColor: '#E7F0FF !important',
          },
          '& .MuiDataGrid-row:focus, & .MuiDataGrid-cell:focus': {
            outline: 'none !important',
          },
          '& .MuiDataGrid-cell:focus-within': {
            outline: 'none !important',
          },
        }}
      />
    </Box>
  );
};

export default AvaiableTablesSkeleton;
